import { type IconType } from "./IconType";
import { IconSize } from "./IconSize";
import classNames from "classnames";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";

type TagProps = JSX.IntrinsicElements["i"];
export interface IconProps extends TagProps {
  /**
   * Which image to use?
   */
  type: IconType;
  /**
   * How large should it be?
   */
  size?: IconSize | number;
  "data-test-id"?: string;
  "data-ta-spec"?: string;
  "data-ta-total"?: number | null;
}

export const Icon = (props: IconProps) => {
  const { type, size = IconSize.FONT_16, className, style: externalStyle, ...rest } = props;
  let cls;
  let style = externalStyle;
  if (typeof size === "number") {
    cls = classNames(type, className);
    style = { ...externalStyle, fontSize: size };
  } else {
    cls = classNames(type, size, className);
  }

  return <i className={cls} style={style} {...rest} data-test-id={props["data-test-id"]} />;
};

/**
 * This is the default button icon that has the correct "default" size
 * - 20px for all buttons on phone
 * - 16px for "small" buttons on tablet and desktop
 * - 20px for "medium" buttons on tablet and desktop
 *
 * - TODO - Make it happen
 * @param props
 * @constructor
 */
export const DefaultButtonIcon = (props: Omit<IconProps, "size">) => {
  const { type, className, ...rest } = props;

  const isMinTablet = useIsMinTabletSize();
  const size = isMinTablet ? IconSize.FONT_20 : IconSize.FONT_16; // 20px default on desktop, 16px on mobile
  const cls = classNames(type, size, className);

  return <i className={cls} {...rest} />;
};
